import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tickets-tickets',
  templateUrl: './tickets-tickets.component.html',
  styleUrls: ['./tickets-tickets.component.scss']
})
export class TicketsTicketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
